import { Outlet, createFileRoute, notFound } from '@tanstack/react-router'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/resources')({
  beforeLoad: ({ params }) => {
    redirectIfPublicPageHidden('resources', params.lang)
    if (params.lang !== 'ru') throw notFound()
  },
  component: Outlet,
  staticData: { layout: 'public' },
})
